import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import {
  startLoadingAnimate,
  stopLoadingAnimate,
} from "services/ducks/loading";
import { DeclaracaoSubtitle, LinhaSubtitle } from "./styles";
import { Row, Col } from "react-bootstrap";
import * as FontAwesome from "@fortawesome/react-fontawesome";
import {
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Card,
  Paper,
} from "@material-ui/core";
import { faHandHoldingUsd, faReceipt } from "@fortawesome/free-solid-svg-icons";
import { ContainerTitle, BoxTitle, FullSizedButton } from "../styles";
import api from "services/structure/api";
import CustomizedMenus from "components/CustomizedMenu";
import CustomizedChart from "components/CustomizedChart";
import { addOffsetToDate } from "services/structure/dateUtils";
import { format } from "date-fns";
import NumberFormat from "react-number-format";

class MeuPlano extends Component {
  state = {
    meuPlano: {
      cnpb: "",
      patrocinadora: "",
      dtAdmissao: 0,
      dtInscricao: 0,
      action: 1,
    },
    regrasExibicao: {
      exibirExtrato: false,
      exibirExtratoBeneficioCD: false,
      exibirAlteracaoContribuicao: false,
      exibirAlteracaoBeneficioCD: false,
      exibirContrachequeCD: false,
      exibirBoletos: false,
      exibirRequerimentos: false,
      exibirInformeRendimentos: false,
      exibirInformeEmprestimos: false,
      exibirInformeContribuicoesExtraordinarias: false,
      exibirSaldoConta: false,
      exibirCoberturaRisco: false,
      exibirUltimasContribuicoes: false,
      exibirGraficoRentabilidade: false
    },
    saldoConta: [],
    coberturaRisco: [],
    ultimasContribuicoes: [],
    rentabilidadeAcumulada: [],
    listaInformeRendimentos: [],
    listaRequerimentos: [],
    listarBoletosContribuicoes: [],
    download: {
      loading: false,
      errors: null,
      file: "",
    },
    botao: 0,
  };

  componentDidUpdate(prevProps){
    if (this.state.id !== prevProps.authData.usuario.pessoa.id) {
      this.setState({ id : prevProps.authData.usuario.pessoa.id })
      this.buscarTodosOsDados();
    }
  }

  componentDidMount() {
    this.buscarTodosOsDados();
  }

  buscarTodosOsDados() {
    window.scrollTo(0, 0);
    const promises = [];
    this.props.startLoadingAnimate();

    const meuPlanoPromise = this.buscarMeuPlano();
    const regrasExibicaoPromise = this.buscarRegrasExibicao();
    const saldoContaPromise = this.buscarSaldoConta();
    const coberturaRiscoPromise = this.buscarCoberturaRisco();
    const ultimasContribuicoesPromise = this.buscarUltimasContribuicoes();
    const portabilidade = this.buscarPortabilidade();
    const rentabilidadeAcumuladaPromise = this.buscarRentabilidadeAcumulada();
    const listaInformeRendimentosPromise = this.listaInformeRendimentos();
    const listaRequerimentosPromise = this.listaRequerimentosJustTitulo();
    const listarBoletosContribuicaoPromise = this.listarBoletosContribuicoes();

    promises.push(meuPlanoPromise);
    promises.push(regrasExibicaoPromise);
    promises.push(saldoContaPromise);
    promises.push(coberturaRiscoPromise);
    promises.push(ultimasContribuicoesPromise);
    promises.push(portabilidade);
    promises.push(rentabilidadeAcumuladaPromise);
    promises.push(listaInformeRendimentosPromise);
    promises.push(listaRequerimentosPromise);
    promises.push(listarBoletosContribuicaoPromise);

    Promise.all(promises)
      .then(values => {
        const newState = Object.assign(...values);
        this.setState(newState);
      })
      .catch(e => {
        console.log(e);
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: "error" });
      })
      .finally(() => this.props.stopLoadingAnimate());
  }

  buscarMeuPlano() {
    return api.get("meu-plano/dados-plano")
      .then(response => {
        const meuPlano = response.data;
        return { meuPlano: meuPlano };
      })
      .catch((err) => console.error(err));
  }
  
  buscarRegrasExibicao() {
    return api.get("meu-plano/regras-exibicao")
      .then(response => {
        const { 
          exibirExtrato,
          exibirExtratoBeneficioCD,
          exibirAlteracaoContribuicao,
          exibirAlteracaoBeneficioCD,
          exibirContrachequeCD,
          exibirBoletos,
          exibirRequerimentos,
          exibirInformeRendimentos,
          exibirInformeEmprestimos,
          exibirInformeContribuicoesExtraordinarias,
          exibirSaldoConta,
          exibirCoberturaRisco,
          exibirUltimasContribuicoes,
          exibirGraficoRentabilidade
        } = response.data;

        return { 
          regrasExibicao: { 
            exibirExtrato,
            exibirExtratoBeneficioCD,
            exibirAlteracaoContribuicao,
            exibirAlteracaoBeneficioCD,
            exibirContrachequeCD,
            exibirBoletos,
            exibirRequerimentos,
            exibirInformeRendimentos,
            exibirInformeEmprestimos,
            exibirInformeContribuicoesExtraordinarias,
            exibirSaldoConta,
            exibirCoberturaRisco,
            exibirUltimasContribuicoes,
            exibirGraficoRentabilidade }};
      })
      .catch((err) => console.error(err));
  }

  buscarSaldoConta() {
    return api.get("meu-plano/saldo-conta")
      .then(response => {
        const dados = response.data;
        return { saldoConta: dados.listaResumoContribuicoesPorIntervalo };
      })
      .catch((err) => console.error(err));
  }

  buscarCoberturaRisco() {
    return api.get("meu-plano/cobertura-risco")
      .then(response => {
        const coberturaRiscos = response.data;
        return { coberturaRisco: coberturaRiscos };
      })
      .catch((err) => console.error(err));
  }

  buscarUltimasContribuicoes() {
    return api.get("meu-plano/ultimas-contribuicoes")
      .then(response => {
        const ultimasContribuicoesRetorno = response.data;
        return { ultimasContribuicoes: ultimasContribuicoesRetorno };
      })
      .catch((err) => console.error(err));
  }
  
  buscarPortabilidade() {
    return api.get("meu-plano/portabilidade")
      .then(response => {
        const portabilidade = response.data;
        return { portabilidade: portabilidade.listaResumoContribuicoesPorIntervalo };
      })
      .catch((err) => console.error(err));
  }

  buscarRentabilidadeAcumulada() {
    return api.get("meu-plano/rentabilidade")
      .then(response => {
        const rentabilidadeAcumuladas = response.data;
        return { rentabilidadeAcumulada: rentabilidadeAcumuladas };
      })
      .catch((err) => console.error(err));
  }

  listaInformeRendimentos() {
    return api.get("/documentos/lista-informe-rendimentos")
      .then(response => {
        const dados = response.data.map((c) => c.ano);
        return { listaInformeRendimentos: dados };
      })
      .catch((err) => console.error(err));
  }

  listarBoletosContribuicoes() {
    return api.get("/documentos/lista-boletos")
      .then(response => {
        const data = response.data;
        const boletos = data.boletos.map(c => c.titulo);
        return { 
          formaPagamentoBoleto: data.formaPagamentoBoleto, 
          listarBoletosContribuicoes: boletos 
        };
      })
      .catch((err) => console.error(err));
  }

  listaRequerimentosJustTitulo() {
    return api.get("/documentos/requerimentos")
      .then(response => {
        const dados = response.data.map((c) => c.titulo);
        return { listaRequerimentos: dados };
      })
      .catch((err) => console.error(err));
  }

  async listaBoletoContribuicao(titulo) {
    return api.get("/documentos/lista-boletos")
      .then(response => {
        const dados = response.data.boletos.filter((c) => c.titulo === titulo);
        return { dados };
      })
      .catch((err) => console.error(err));
  }

  async listaRequerimentos(titulo) {
    return api.get("/documentos/requerimentos")
      .then(response => {
        const dados = response.data.filter((c) => c.titulo === titulo);
        return { dados };
      })
      .catch((err) => console.error(err));
  }

  downloadExtratoParticipante() {
    this.props.startLoadingAnimate();
    return api.get("documentos/extrato-participante", { responseType: "blob" })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Extrato-Participante.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
      }).finally(() => this.props.stopLoadingAnimate());
  }
  
  downloadExtratoBeneficioParticipante() {
    this.props.startLoadingAnimate();
    return api.get("documentos/extrato-beneficio-cd", { responseType: "blob" })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Extrato-Beneficio-Participante.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
      }).finally(() => this.props.stopLoadingAnimate());
  }

  downloadInformeRendimentos = async () => {
    this.props.startLoadingAnimate();
    return await api.get("documentos/informe-rendimentos/" +  (new Date().getFullYear() - 1), {
        responseType: "blob",
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Informe-Rendimentos.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
      }).finally(() => this.props.stopLoadingAnimate());
  };

  downloadInformeEmprestimos = async () => {
    this.props.startLoadingAnimate();
    return await api.get("documentos/declaracaoEmprestimoIR", {
        responseType: "blob",
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Informe-Emprestimos.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
      }).finally(() => this.props.stopLoadingAnimate());
  };

  downloadInformeContribuicoesExtraordinarias = async () => {
    this.props.startLoadingAnimate();
    return await api.get("documentos/contribuicoes-extraordinarias-ir", {
        responseType: "blob",
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Informe-Contribuicoes-Extraordinarias.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
      }).finally(() => this.props.stopLoadingAnimate());
  };

  downloadBoletoContribuicao = async (titulo) => {
    const listaContribuicao = await this.listaBoletoContribuicao(titulo);
    const idBoleto = listaContribuicao.dados[0].idDocumento;
    this.props.startLoadingAnimate();

    return await api
      .get("documentos/boleto/" + idBoleto, {
        responseType: "blob",
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Boleto-Contribuicao.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((err) => {
        console.error(err)
        const mensagem = "Não foi possível conectar-se ao servidor. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
      }).finally(() => this.props.stopLoadingAnimate());
  };

  downloadRequerimentos = async (titulo) => {
    const listaReq = await this.listaRequerimentos(titulo);
    const link = document.createElement("a");
    link.href = listaReq.dados[0].url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  maskCNPB = value => {
    if (!value) {
      return null;
    }
    return value
      .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d{4})(\d{4})(\d{2})$/, '$1.$2-$3')
  }

  renderGridTipoContribuicaoMobile = ultimasContribuicoes => {
    return (
      <div>
        <div>
          <div className="card-row">
            <div className="card-cell tipo-contribuicao">
              <div className="card-cell-title">{ultimasContribuicoes.tipoContribuicao}</div>
            </div>
            <div className="card-cell participante">
              <div className="card-cell-title">Participante</div>
              <div className="card-cell-value">
                <NumberFormat
                  value={ultimasContribuicoes.contribuicaoParticipante.valor.toFixed(2)}
                  displayType={"text"}
                  decimalSeparator={","}
                  decimalScale={2}
                  thousandSeparator={"."}
                  isNumericString={true}
                  prefix={"R$ "}
                />
              </div>
            </div>
            {
              this.isPlanoPatrocinado() &&
                <div className="card-cell patrocinadora">
                  <div className="card-cell-title">Patrocinador</div>
                  <div className="card-cell-value">
                    <NumberFormat
                      value={ultimasContribuicoes.contribuicaoPatrocinadora.valor.toFixed(2)}
                      displayType={"text"}
                      decimalSeparator={","}
                      decimalScale={2}
                      thousandSeparator={"."}
                      isNumericString={true}
                      prefix={"R$ "}
                    />
                  </div>
                </div>
            }
            <div className="card-cell total">
              <div className="card-cell-title">Total</div>
              <div className="card-cell-value">
                <NumberFormat
                  value={(ultimasContribuicoes.contribuicaoParticipante.valor + ultimasContribuicoes.contribuicaoPatrocinadora.valor).toFixed(2)}
                  displayType={"text"}
                  decimalSeparator={","}
                  decimalScale={2}
                  thousandSeparator={"."}
                  isNumericString={true}
                  prefix={"R$ "}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderGridUltimasContribuicoesMobile = () => {
    if (Object.keys(this.state.ultimasContribuicoes).length) {
      return (
        <div>
          <BoxTitle className="box-title title-ultimas-contribuicoes">ÚLTIMAS CONTRIBUIÇÕES</BoxTitle>
          <div className="grid-ultimas-contribuicoes">
            <div className="grid-ultimas-contribuicoes-body">
              <div className="card-header card-row">
                <div className="card-cell header-ultimas-contribuicoes">
                  <div className="card-cell-value">{format(addOffsetToDate(new Date(this.state.ultimasContribuicoes.dtUltimoMesCompetenciaPago)), "MM/yyyy")}</div>
                </div>
              </div>
              {
                this.state.ultimasContribuicoes.ultimasContribuicoesPorDtRepasse
                  .map(ultimasContribuicoes => this.renderGridTipoContribuicaoMobile(ultimasContribuicoes))
              }
            </div>
            <br clear="all"/>
          </div>
        </div>
      )
    }
  }

  renderGridUltimasContribuicoesDesktop = () => {
    if (Object.keys(this.state.ultimasContribuicoes).length) {
      return (
        <div>
          <BoxTitle className="box-title">ÚLTIMAS CONTRIBUIÇÕES</BoxTitle>
          <TableContainer component={Paper} className="table-ultimas-contribuicoes">
            <Table size="small">
              <TableHead className="header-ultimas-contribuicoes">
              <TableRow>
                <TableCell>
                  {format(addOffsetToDate(new Date(this.state.ultimasContribuicoes.dtUltimoMesCompetenciaPago)), "MM/yyyy")}
                </TableCell>
                <TableCell>
                  Participante
                </TableCell>
                {
                  this.isPlanoPatrocinado() &&
                  <TableCell>
                    Patrocinador
                  </TableCell>
                }
                <TableCell>
                  Total
                </TableCell>
                </TableRow>
              </TableHead>
              <TableHead>
                {
                  this.state.ultimasContribuicoes.ultimasContribuicoesPorDtRepasse
                    .map(ultimasContribuicoes => this.renderGridTipoContribuicaoDesktop(ultimasContribuicoes))
                }
              </TableHead>
              <TableHead className="rodapeTotal">
              <TableRow>
                <TableCell>
                  Total
                </TableCell>
                <TableCell>
                  <NumberFormat
                    value={this.state.ultimasContribuicoes.totalizadores[0].valor.toFixed(2)}
                    displayType={"text"}
                    decimalSeparator={","}
                    decimalScale={2}
                    thousandSeparator={"."}
                    isNumericString={true}
                    prefix={"R$ "}
                  />
                </TableCell>
                {
                  this.isPlanoPatrocinado() &&
                  <TableCell>
                    <NumberFormat
                      value={this.state.ultimasContribuicoes.totalizadores[1].valor.toFixed(2)}
                      displayType={"text"}
                      decimalSeparator={","}
                      decimalScale={2}
                      thousandSeparator={"."}
                      isNumericString={true}
                      prefix={"R$ "}
                    />
                  </TableCell>
                }
                <TableCell>
                  <NumberFormat
                    value={this.state.ultimasContribuicoes.totalizadores[2].valor.toFixed(2)}
                    displayType={"text"}
                    decimalSeparator={","}
                    decimalScale={2}
                    thousandSeparator={"."}
                    isNumericString={true}
                    prefix={"R$ "}
                  />
                </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
        </div>
      );
    }
  }

  renderGridTipoContribuicaoDesktop = (ultimasContribuicoes) => {
    return (
      <TableRow className="body-ultimas-contribuicoes" key={ultimasContribuicoes.tipoContribuicao}>
        <TableCell>
          {ultimasContribuicoes.tipoContribuicao}
        </TableCell>
        <TableCell>
          <NumberFormat
            value={ultimasContribuicoes.contribuicaoParticipante.valor.toFixed(2)}
            displayType={"text"}
            decimalSeparator={","}
            decimalScale={2}
            thousandSeparator={"."}
            isNumericString={true}
            prefix={"R$ "}
          />
        </TableCell>
        {
          this.isPlanoPatrocinado() &&
          <TableCell>
            <NumberFormat
              value={ultimasContribuicoes.contribuicaoPatrocinadora.valor.toFixed(2)}
              displayType={"text"}
              decimalSeparator={","}
              decimalScale={2}
              thousandSeparator={"."}
              isNumericString={true}
              prefix={"R$ "}
            />
          </TableCell>
        }
        <TableCell>
          <NumberFormat
            value={(ultimasContribuicoes.contribuicaoParticipante.valor + ultimasContribuicoes.contribuicaoPatrocinadora.valor).toFixed(2)}
            displayType={"text"}
            decimalSeparator={","}
            decimalScale={2}
            thousandSeparator={"."}
            isNumericString={true}
            prefix={"R$ "}
          />
        </TableCell>
      </TableRow>
    )
  }

  renderGridSaldoDeContaMobile = (itemConta, title) => {
    if (this.containsElementoSaldoContas(itemConta)) {
      const total = itemConta[0].totalSaldoConta;
      return ( 
        <div className="grid-saldo-conta">
          <div className="grid-saldo-conta-body">
            <div className="card-header card-row">
              <div className="card-cell">
                <div className="card-cell-value titleSaldoConta">{title}</div>
              </div>
            </div>
            <div className="grid-header-divisor"></div>
            {itemConta[0].listaTiposDeContribuicaoAgrupadas
              .map((contribuicoesAgrupadas) => (
                <div className="card-row">
                  <div className="card-cell">
                    <div className="card-cell-title">{contribuicoesAgrupadas.tipoDeAgrupamento.toUpperCase()}</div>
                    <div className="card-cell-value">
                      {this.renderValorAtualizado(contribuicoesAgrupadas, valorAtualizado => (
                          <NumberFormat
                            value={valorAtualizado.valor.toFixed(2)}
                            displayType={"text"}
                            decimalSeparator={","}
                            decimalScale={2}
                            thousandSeparator={"."}
                            isNumericString={true}
                            prefix={"R$ "}
                          />
                      ))}</div>
                  </div>
                </div>
              ))}
              <div  className="card-footer card-row">
                <div className="card-cell">
                  <div className="card-cell-title">TOTAL</div>
                  <div className="card-cell-value">
                    <NumberFormat
                      value={total.valor.toFixed(2)}
                      displayType={"text"}
                      decimalSeparator={","}
                      decimalScale={2}
                      thousandSeparator={"."}
                      isNumericString={true}
                      prefix={"R$ "}
                    />
                  </div>
                </div>
              </div>
          </div>
          <br clear="all"/>
        </div>
      )
    }
  }

  renderGridSaldoDeContaDesktop = (itemConta, title) => {
    if (this.containsElementoSaldoContas(itemConta)) {
      return (
        <TableContainer
          component={Card}
          className="table-saldo-conta"
        >
          <Table size="medium">
            <TableHead>
            <TableRow>
              <TableCell className="titleSaldoConta" colSpan={2}>{title}</TableCell>
              </TableRow>
            </TableHead>
            {itemConta[0].listaTiposDeContribuicaoAgrupadas
              .map((contribuicoesAgrupadas, index) => (
                <TableBody key={index}>
                <TableRow>
                  <TableCell className="tipoContribuicao">{contribuicoesAgrupadas.tipoDeAgrupamento.toUpperCase()}</TableCell>
                    {this.renderValorAtualizado(contribuicoesAgrupadas, valorAtualizado => (
                    <TableCell className="valorContribuicao" key={valorAtualizado.rotulo}>
                      <NumberFormat
                        value={valorAtualizado.valor.toFixed(2)}
                        displayType={"text"}
                        decimalSeparator={","}
                        decimalScale={2}
                        thousandSeparator={"."}
                        isNumericString={true}
                        prefix={"R$ "}
                      />
                    </TableCell>
                  ))}
                </TableRow>
                </TableBody>
              ))}
            <TableHead>
              {this.renderTotalSaldoContas(itemConta)}
            </TableHead>
          </Table>
        </TableContainer>
      );
    }
  }

  containsElementoSaldoContas = itemConta => {
    return itemConta?.length && itemConta[0]?.listaTiposDeContribuicaoAgrupadas?.length;
  }

  renderValorAtualizado = (contribuicoesAgrupadas, renderFunc) => {
    return contribuicoesAgrupadas.valoresContribuicoesAgrupadas.filter(valorContribuicao => valorContribuicao.rotulo === 'Valor Atualizado').map(renderFunc)
  }

  renderTotalSaldoContas(itemConta) {
    const total = itemConta[0].totalSaldoConta
    return (
      <TableRow>
        <TableCell className={`titleRodape tipoContribuicao`}>TOTAL</TableCell>
        <TableCell className={`titleRodape valorContribuicao`}>
          <NumberFormat
            value={total.valor.toFixed(2)}
            displayType={"text"}
            decimalSeparator={","}
            decimalScale={2}
            thousandSeparator={"."}
            isNumericString={true}
            prefix={"R$ "}
          />
        </TableCell>
      </TableRow>
    )
  }

  renderGridCapitalSeguradoDesktop = () => {
    if (this.state.coberturaRisco?.capitalSegurado?.length) {
      return (
        <TableContainer
          TableContainer
          component={Card}
          className="table-capital-segurado"
        >
          <Table size="medium">
            <TableHead>
              <TableCell className="titleCapitalSegurado" colSpan={2}>CAPITAL SEGURADO</TableCell>
            </TableHead>
              {this.state.coberturaRisco.capitalSegurado.map(capitalSegurado => (
                  <TableBody key={capitalSegurado.rotulo}>
                    <TableCell className="tipoContribuicao">{capitalSegurado.rotulo}</TableCell>
                    <TableCell className="valorContribuicao">
                      <NumberFormat
                        value={capitalSegurado.valor.toFixed(2)}
                        displayType={"text"}
                        decimalSeparator={","}
                        decimalScale={2}
                        thousandSeparator={"."}
                        isNumericString={true}
                        prefix={"R$ "}
                      />
                    </TableCell>
                  </TableBody>
                ))}
            <TableHead>
              <TableRow>
                <TableCell className={`titleRodape tipoContribuicao`}>TOTAL</TableCell>
                <TableCell className={`titleRodape valorContribuicao`}>
                  <NumberFormat
                    value={this.state.coberturaRisco.capitalSegurado.map(c => c.valor).reduce((a, b) => a + b).toFixed(2)}
                    displayType={"text"}
                    decimalSeparator={","}
                    decimalScale={2}
                    thousandSeparator={"."}
                    isNumericString={true}
                    prefix={"R$ "}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      );
    }
  }

  renderGridCapitalSeguradoMobile = () => {
    if (this.state.capitalSegurado?.contribuicoesRisco?.length) {
      return (
        <div className="grid-capital-segurado">
          <div className="grid-cobertura-risco-body">
            <div className="card-header card-row">
              <div className="card-cell">
                <div className="card-cell-value titleCapitalSegurado">CAPITAL SEGURADO</div>
              </div>
            </div>
            <div className="grid-header-divisor"></div>
            {this.state.coberturaRisco.contribuicoesRisco.map((contribuicaoRisco) => (
                <div className="card-row">
                  <div className="card-cell">
                    <div className="card-cell-title">{contribuicaoRisco.rotulo}</div>
                    <div className="card-cell-value">
                      <NumberFormat
                        value={contribuicaoRisco.valor.toFixed(2)}
                        displayType={"text"}
                        decimalSeparator={","}
                        decimalScale={2}
                        thousandSeparator={"."}
                        isNumericString={true}
                        prefix={"R$ "}
                      />
                    </div>
                  </div>
                </div>
              ))}
              <div  className="card-footer card-row">
                <div className="card-cell">
                  <div className="card-cell-title">TOTAL</div>
                  <div className="card-cell-value">
                    <NumberFormat
                      value={this.state.coberturaRisco.totalContribuicoesRisco.valor.toFixed(2)}
                      displayType={"text"}
                      decimalSeparator={","}
                      decimalScale={2}
                      thousandSeparator={"."}
                      isNumericString={true}
                      prefix={"R$ "}
                    />
                  </div>
                </div>
              </div>
          </div>
          <br clear="all"/>
        </div>
      )
    }
  }

  renderGridCoberturaDeRiscoMobile = () => {
    if (this.state.coberturaRisco?.contribuicoesRisco?.length) {
      return (
        <div className="grid-cobertura-risco">
          <div className="grid-cobertura-risco-body">
            <div className="card-header card-row">
              <div className="card-cell">
                <div className="card-cell-value titleCoberturaRisco">COBERTURA DE RISCO</div>
              </div>
            </div>
            <div className="grid-header-divisor"></div>
            {this.state.coberturaRisco.contribuicoesRisco.map((contribuicaoRisco) => (
                <div className="card-row">
                  <div className="card-cell">
                    <div className="card-cell-title">{contribuicaoRisco.rotulo}</div>
                    <div className="card-cell-value">
                      <NumberFormat
                        value={contribuicaoRisco.valor.toFixed(2)}
                        displayType={"text"}
                        decimalSeparator={","}
                        decimalScale={2}
                        thousandSeparator={"."}
                        isNumericString={true}
                        prefix={"R$ "}
                      />
                    </div>
                  </div>
                </div>
              ))}
              <div  className="card-footer card-row">
                <div className="card-cell">
                  <div className="card-cell-title">TOTAL</div>
                  <div className="card-cell-value">
                    <NumberFormat
                      value={this.state.coberturaRisco.totalContribuicoesRisco.valor.toFixed(2)}
                      displayType={"text"}
                      decimalSeparator={","}
                      decimalScale={2}
                      thousandSeparator={"."}
                      isNumericString={true}
                      prefix={"R$ "}
                    />
                  </div>
                </div>
              </div>
          </div>
          <br clear="all"/>
        </div>
      )
    }
  }

  renderGridCoberturaDeRiscoDesktop = () => {
    if (Object.keys(this.state.coberturaRisco).length > 0 && this.state.coberturaRisco.contribuicoesRisco.length > 0) {
      return (
        <TableContainer
          TableContainer
          component={Card}
          className="table-cobertura-risco"
        >
          <Table size="medium">
            <TableHead>
              <TableCell className="titleCoberturaRisco" colSpan={2}>COBERTURA DE RISCO</TableCell>
            </TableHead>
            {this.state.coberturaRisco.contribuicoesRisco.map(contribuicaoRisco => (
                <TableBody key={contribuicaoRisco.rotulo}>
                  <TableCell className="tipoContribuicao">{contribuicaoRisco.rotulo}</TableCell>
                  <TableCell className="valorContribuicao">
                    <NumberFormat
                      value={contribuicaoRisco.valor.toFixed(2)}
                      displayType={"text"}
                      decimalSeparator={","}
                      decimalScale={2}
                      thousandSeparator={"."}
                      isNumericString={true}
                      prefix={"R$ "}
                    />
                  </TableCell>
                </TableBody>
              ))}
            <TableHead>
              <TableRow>
                <TableCell className={`titleRodape tipoContribuicao`}>TOTAL</TableCell>
                <TableCell className={`titleRodape valorContribuicao`}>
                  <NumberFormat
                    value={this.state.coberturaRisco.totalContribuicoesRisco.valor.toFixed(2)}
                    displayType={"text"}
                    decimalSeparator={","}
                    decimalScale={2}
                    thousandSeparator={"."}
                    isNumericString={true}
                    prefix={"R$ "}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
      );
    }
  }

  navigateTo(route) {
    this.props.history.push(route);
  }

  renderBotoesMenuPrincipal = () => {
    return (
      <Col sm={!isMobile ? 4 : 6} className="meu-plano-box-botoes-menu-principal">
        { isMobileOnly ?
          <img
            src={process.env.PUBLIC_URL + '/meu_plano.png'}
            className="meu-plano-subtitle"
            alt=""
          />
        : null }
        { this.state.regrasExibicao.exibirExtrato ? 
          <FullSizedButton
            type="submit"
            className="extrato-participante"
            variant="contained"
            onClick={() => this.downloadExtratoParticipante()}
          >
            <FontAwesome.FontAwesomeIcon
              icon={faReceipt}
              className="extrato-participante-icon"
            />
            <span className="botao-meu-plano">
              EXTRATO DO PARTICIPANTE
            </span>
          </FullSizedButton>
        : null 
        }
        { this.state.regrasExibicao.exibirExtratoBeneficioCD ? 
          <FullSizedButton
            type="submit"
            className="extrato-participante"
            variant="contained"
            onClick={() => this.downloadExtratoBeneficioParticipante()}
          >
            <FontAwesome.FontAwesomeIcon
              icon={faReceipt}
              className="extrato-participante-icon"
            />
            <span className="botao-meu-plano">
              EXTRATO DO BENEFÍCIO DO PARTICIPANTE
            </span>
          </FullSizedButton>
        : null 
        }
        { 
          this.state.regrasExibicao.exibirAlteracaoContribuicao ?
          <FullSizedButton
            type="submit"
            variant="contained"
            className="btn-alterar-contribuicao"
            onClick={() =>
              this.navigateTo("/app/meu-plano-alterar-contribuicao")
            }
          >
            <FontAwesome.FontAwesomeIcon
              icon={faHandHoldingUsd}
              className="alterar-contribuicao-icon"
            />
            <span className="botao-meu-plano">
              ALTERAR CONTRIBUIÇÃO
            </span>
          </FullSizedButton>
          : null 
        }
        { 
          this.state.regrasExibicao.exibirAlteracaoBeneficioCD ?
          <FullSizedButton
            type="submit"
            variant="contained"
            className="btn-alterar-contribuicao"
            onClick={() =>
              this.navigateTo("/app/meu-plano-alterar-beneficio-cd")
            }
          >
            <FontAwesome.FontAwesomeIcon
              icon={faHandHoldingUsd}
              className="alterar-contribuicao-icon"
            />
            <span className="botao-meu-plano">
              ALTERAR BENEFÍCIO CD
            </span>
          </FullSizedButton>
          : null 
        }

        { 
          this.state.regrasExibicao.exibirContrachequeCD ?
          <FullSizedButton
            type="submit"
            variant="contained"
            className="btn-alterar-contribuicao"
            onClick={() =>
              this.navigateTo("/app/meu-plano-contracheque")
            }
          >
            <FontAwesome.FontAwesomeIcon
              icon={faReceipt}
              className="extrato-participante-icon"
            />
            <span className="botao-meu-plano">
              CONTRACHEQUES
            </span>
          </FullSizedButton>
          : null 
        }

        { this.state.regrasExibicao.exibirBoletos &&
          this.state.listarBoletosContribuicoes.length > 0 ?
          <CustomizedMenus
            title="BOLETOS DE CONTRIBUIÇÃO"
            lista={this.state.listarBoletosContribuicoes}
            onClick={this.downloadBoletoContribuicao}
          ></CustomizedMenus>
        : null }
        { this.state.regrasExibicao.exibirRequerimentos &&
          this.state.listaRequerimentos.length > 0 ?
          <CustomizedMenus
            title="REQUERIMENTOS"
            lista={this.state.listaRequerimentos}
            onClick={this.downloadRequerimentos}
          ></CustomizedMenus>
        : null }

        { 
          this.state.regrasExibicao.exibirInformeRendimentos ?
          <FullSizedButton
            type="submit"
            variant="contained"
            className="btn-alterar-contribuicao"
            onClick={this.downloadInformeRendimentos}
          >
            <FontAwesome.FontAwesomeIcon
              icon={faReceipt}
              className="extrato-participante-icon"
            />
            <span className="botao-meu-plano">
            INFORME DE RENDIMENTOS
            </span>
          </FullSizedButton>
          : null 
        }

        { 
          this.state.regrasExibicao.exibirInformeEmprestimos ?
          <FullSizedButton
            type="submit"
            variant="contained"
            className="btn-alterar-contribuicao"
            onClick={this.downloadInformeEmprestimos}
          >
            <FontAwesome.FontAwesomeIcon
              icon={faReceipt}
              className="extrato-participante-icon"
            />
            <span className="botao-meu-plano">
            INFORME DE EMPRÉSTIMOS
            </span>
          </FullSizedButton>
          : null 
        }

        { 
          this.state.regrasExibicao.exibirInformeContribuicoesExtraordinarias ?
          <FullSizedButton
            type="submit"
            variant="contained"
            className="btn-alterar-contribuicao"
            onClick={this.downloadInformeContribuicoesExtraordinarias}
          >
            <FontAwesome.FontAwesomeIcon
              icon={faReceipt}
              className="extrato-participante-icon"
            />
            <span className="botao-meu-plano">
            INFORME DE CONTRIBUIÇÕES EXTRAORDINÁRIAS
            </span>
          </FullSizedButton>
          : null 
        }


      </Col>
    )
  }

  isPlanoPatrocinado = () => {
    return this.props.authData?.usuario?.pessoa?.planoInstituido === "PATROCINADO";
  }

  renderInformacoesGeraisPlano = () => {
    let dataAdmissao = "Não Informado";
    if (this.state.meuPlano.dtAdmissao) {
      dataAdmissao = format(addOffsetToDate(new Date(this.state.meuPlano.dtAdmissao)), "dd/MM/yyyy");
    }

    let dataInscricao = "Não Informado";
    if (this.state.meuPlano.dtInscricao) {
      dataInscricao = format(addOffsetToDate(new Date(this.state.meuPlano.dtInscricao)), "dd/MM/yyyy");
    } 

    return (
      <Col sm={!isMobile ? 3 : isTablet ? 12 : 6} className="meu-plano-detalhes-plano">
        <Row>
          <Col sm={isTablet ? 6 : 12}>
            <LinhaSubtitle>
              <DeclaracaoSubtitle>CNPB: </DeclaracaoSubtitle>  <br/> 
              <span>{this.maskCNPB(this.state.meuPlano.cnpb)}</span>
            </LinhaSubtitle>
            <LinhaSubtitle>
              <DeclaracaoSubtitle>CNPJ Plano: </DeclaracaoSubtitle>  <br/>
              <span>{this.maskCNPB(this.state.meuPlano.cnpjPlano || this.state.meuPlano.cnpb)}</span>
            </LinhaSubtitle>
            <LinhaSubtitle>
              <DeclaracaoSubtitle>CNPJ Entidade: </DeclaracaoSubtitle>  <br/>
              <span>{this.maskCNPB(this.state.meuPlano.cnpjEntidade || this.state.meuPlano.cnpb)}</span>
            </LinhaSubtitle>
            {this.isPlanoPatrocinado() &&
              <LinhaSubtitle>
                <DeclaracaoSubtitle>PATROCINADOR:</DeclaracaoSubtitle> <br/>
                <span>{this.state.meuPlano.patrocinadora}</span>
              </LinhaSubtitle>            
            }
          </Col>
        <Col sm={isTablet ? 6 : 12}>
          {this.isPlanoPatrocinado() &&
            <LinhaSubtitle>
              <DeclaracaoSubtitle>DATA DE ADMISSÃO: </DeclaracaoSubtitle> <br/>
              <span>{dataAdmissao}</span>
            </LinhaSubtitle>
          }
          <LinhaSubtitle>
            <DeclaracaoSubtitle>DATA DE INSCRIÇÃO: </DeclaracaoSubtitle> <br/>
            <span>{dataInscricao}</span>
          </LinhaSubtitle>
        </Col>
        </Row>
      </Col>
    )
  }

  render() {
    return (
      <div className="meu-plano">
        <ContainerTitle>MEU PLANO </ContainerTitle>
        <Row className="meu-plano-title-container">
          { !isMobileOnly && this.renderBotoesMenuPrincipal() }
          <Col sm={!isMobile ? 5 : 6}>
            {!isMobileOnly && (
              <img src={process.env.PUBLIC_URL + '/meu_plano.png'} className="meu-plano-subtitle" alt=""
              />
            )}
          </Col>
          { isMobileOnly && this.renderBotoesMenuPrincipal() }
          { this.renderInformacoesGeraisPlano() }
        </Row>
        <div>
        { this.state.regrasExibicao.exibirSaldoConta ?
          <Row>
            <Col sm={!isMobile ? 6 : isTablet ? 12 : 6} className="colSaldoContas">
              {!isMobileOnly && this.renderGridSaldoDeContaDesktop(this.state.saldoConta, "SALDO DE CONTA")}
              {isMobileOnly && this.renderGridSaldoDeContaMobile(this.state.saldoConta, "SALDO DE CONTA")}
            </Col>
            <Col sm={!isMobile ? 6 : isTablet ? 12 : 6} className="colSaldoContas">
              {!isMobileOnly && this.renderGridSaldoDeContaDesktop(this.state.portabilidade, "PORTABILIDADE")}
              {isMobileOnly && this.renderGridSaldoDeContaMobile(this.state.portabilidade, "PORTABILIDADE")}
            </Col>
          </Row>
        : null }
        { this.state.regrasExibicao.exibirCoberturaRisco ?
          <Row>
            <Col sm={!isMobile ? 6 : isTablet ? 12 : 6} className="colCapitalSegurado">
              {!isMobileOnly && this.renderGridCapitalSeguradoDesktop()}
              {isMobileOnly && this.renderGridCapitalSeguradoMobile()}
            </Col>
            <Col sm={!isMobile ? 6 : isTablet ? 12 : 6} className="colCoberturaRisco">
              {!isMobileOnly && this.renderGridCoberturaDeRiscoDesktop()}
              {isMobileOnly && this.renderGridCoberturaDeRiscoMobile()}
            </Col>
          </Row>
        : null }
        </div>
        <div>
        { this.state.regrasExibicao.exibirUltimasContribuicoes ?
          <Row>
            <Col sm={12} className="colUltimasContribuicoes">
              {!isMobileOnly && this.renderGridUltimasContribuicoesDesktop()}
              {isMobileOnly && this.renderGridUltimasContribuicoesMobile()}
            </Col>
          </Row>
        : null }
        </div>
        { this.state.regrasExibicao.exibirGraficoRentabilidade ?
          <Row className="rentabilidade-acumulada">
            <Col sm={12}>
              <BoxTitle className="box-title">RENTABILIDADE ACUMULADA</BoxTitle>
              <div className="grafico">
                { 
                  this.state.rentabilidadeAcumulada && 
                  <CustomizedChart 
                    xAxisType="date"
                    xAxisFormat="MMM"
                    vAxisFormat="percent"
                    subtitle="Últimos %d meses"
                    dados={this.state.rentabilidadeAcumulada.investimentos}>
                  </CustomizedChart> 
                }
              </div>
            </Col>
          </Row>
        : null }
      </div>
    );
  }
}

const mapStateToProps = store => ({
  authData: store.authState,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ startLoadingAnimate, stopLoadingAnimate }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withSnackbar(MeuPlano)));
